import React from 'react'
import { useIsMobile } from '../../lib/hooks/useIsMobile'
import Script from 'next/script'

type Props = {
  bookingEngine: string
}

const RegiondoBookingEngine = ({ bookingEngine }: Props) => {
  const isMobile = useIsMobile()
  return (
    <div className="relative">
      <Script
        id="regiondo-booking-engine"
        strategy="afterInteractive"
        src="https://widgets.regiondo.net/booking/v1/booking-widget.min.js"
      />
      <div
        style={{
          minHeight: '818px',
          maxWidth: isMobile ? 'calc(100vw - 1.5rem)' : ' ',
        }}
        suppressHydrationWarning={true}
        dangerouslySetInnerHTML={{
          __html: bookingEngine
            .replace(/\\\"/g, '"')
            .replace(
              '<script type="text/javascript" src="https://widgets.regiondo.net/booking/v1/booking-widget.min.js"></script>',
              '',
            ),
        }}
      />
    </div>
  )
}

export default RegiondoBookingEngine
